var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdjedTestnetWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 63,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1559.81936 256.70998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1281.28532,28.21816a32.08307,32.08307,0,0,0-9.517-1.9549H1211.867V144.21751h58.68387a31.83657,31.83657,0,0,0,10.73444-1.99937c18.29648-6.71785,31.76785-29.68854,31.76785-56.99555S1299.5818,34.93611,1281.28532,28.21816Zm-3.00351,82.28538a22.54686,22.54686,0,0,1-18.74084,9.92583h-20.35806V49.40262H1259.07a24.54069,24.54069,0,0,1,20.71352,11.1699c4.40748,6.89564,6.007,15.15087,6.007,24.01919A46.34736,46.34736,0,0,1,1278.28181,110.50354Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.45949,21.53589V73.98164a35.9135,35.9135,0,0,0-26.46276-11.99625c-20.96231,0-37.96156,18.96293-37.96156,42.35124s16.99925,42.35114,37.96156,42.35114a35.91309,35.91309,0,0,0,26.46276-11.99625V144.884h25.12106V21.53589Zm-19.416,100.78623a17.98549,17.98549,0,1,1,17.98549-17.98549A17.98349,17.98349,0,0,1,1515.04346,122.32212Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.77653,111.18779a41.908,41.908,0,0,0,.64867-7.36662c0-23.45925-19.32729-42.47556-43.15991-42.47556-23.83251,0-43.1598,19.01631-43.1598,42.47556,0,23.45947,19.32729,42.47566,43.1598,42.47566a43.89628,43.89628,0,0,0,8.56633-.83524,43.27152,43.27152,0,0,0,26.70271-13.23144l-1.51949-1.93722-11.88073-15.13307a23.13651,23.13651,0,0,1-18.31438,8.59291c-9.36588,0-17.38118-5.18946-20.73115-12.565ZM1400.26139,96.348a10.54507,10.54507,0,0,1,.87983-4.061v-.00889c2.14158-4.94952,7.94424-8.53944,14.84866-8.76159h.02668c.22215-.01779.44431-.01779.66646-.01779,9.00164,0,16.31489,5.7315,16.41262,12.84928Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1343.47211,
    cy: 36.90067,
    r: 15.60021,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.08794,151.79961V63.62451H1330.7488v85.72366a10.78258,10.78258,0,0,1-9.79851,10.87332q-.38.02645-.76478.02657H1308.699v21.74432h20.52566a18.73964,18.73964,0,0,0,6.26076-1.02771,30.944,30.944,0,0,0,20.60322-29.1673",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1239.1829,
    y1: 120.42939,
    x2: 1239.1829,
    y2: 49.40269,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1149.24239,
    y: 2.47495,
    width: 15.51969,
    height: 155.55882,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.76368,113.95072a27.53694,27.53694,0,0,1-10.93017,22.7058,36.89706,36.89706,0,0,1-11.41328,5.73684,47.58562,47.58562,0,0,1-13.34568,1.9324,49.33716,49.33716,0,0,1-13.64765-1.9324,34.42116,34.42116,0,0,1-11.29252-5.73684,27.89886,27.89886,0,0,1-7.66922-9.54127,28.503,28.503,0,0,1-2.89863-13.16453V89.79563a27.83834,27.83834,0,0,1,2.959-13.16453,28.9861,28.9861,0,0,1,7.85043-9.662,35.14583,35.14583,0,0,1,11.35288-6.03877,44.50558,44.50558,0,0,1,13.52684-2.05319,48.30977,48.30977,0,0,1,14.01,2.05319,34.42113,34.42113,0,0,1,11.29252,6.03877,28.20122,28.20122,0,0,1,7.54847,9.72242A30.7979,30.7979,0,0,1,710.824,89.856ZM692.64735,92.815a18.11626,18.11626,0,0,0-1.63044-8.03157,15.88214,15.88214,0,0,0-4.10637-5.25374,17.754,17.754,0,0,0-6.03878-2.8986,21.0149,21.0149,0,0,0-12.50026,0,16.60656,16.60656,0,0,0-6.03877,2.8986,15.51989,15.51989,0,0,0-4.16677,5.31413,18.66026,18.66026,0,0,0-1.63045,8.09195v17.81439a15.39886,15.39886,0,0,0,5.25375,13.28531,20.22991,20.22991,0,0,0,12.50026,3.9252,24.1556,24.1556,0,0,0,6.03878-.9662,15.76153,15.76153,0,0,0,6.03877-2.959,15.51976,15.51976,0,0,0,4.16677-5.31412,18.11641,18.11641,0,0,0,1.63045-8.03157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.615,107.48923v4.22714a17.20987,17.20987,0,0,0,1.50969,7.54847,14.73521,14.73521,0,0,0,3.98562,5.07257,15.942,15.942,0,0,0,5.73681,2.83822,24.15492,24.15492,0,0,0,6.8842.9662,40.76048,40.76048,0,0,0,9.36012-1.38891,25.36251,25.36251,0,0,0,10.93017-6.03877l5.31415,6.03877c1.7512,1.93241,3.5025,4.046,5.19335,6.03877a36.23282,36.23282,0,0,1-14.67427,9.36011,58.2745,58.2745,0,0,1-15.82156,2.29473,51.20844,51.20844,0,0,1-13.82875-1.872,34.60211,34.60211,0,0,1-11.47364-5.67645,27.17511,27.17511,0,0,1-7.91078-9.60165,29.77148,29.77148,0,0,1-2.83823-13.52685V91.728a33.394,33.394,0,0,1,2.59663-13.708,29.71148,29.71148,0,0,1,7.00491-10.32631,33.99822,33.99822,0,0,1,10.93017-6.46148A41.00306,41.00306,0,0,1,894.282,58.8771a44.44516,44.44516,0,0,1,14.01,2.23435,32.12625,32.12625,0,0,1,11.051,6.34071,28.56391,28.56391,0,0,1,7.18616,10.08475,34.542,34.542,0,0,1,2.53627,13.52686v16.42546Zm33.51521-15.39888a15.58012,15.58012,0,0,0-4.89139-12.8022,19.42319,19.42319,0,0,0-23.73234.12078,15.21749,15.21749,0,0,0-4.95183,12.43987v2.71745h33.33405Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.53185,89.01058a29.40893,29.40893,0,0,1,8.03158-21.92075,28.92573,28.92573,0,0,1,21.07535-8.03157,67.2111,67.2111,0,0,1,10.44706.96621,58.57458,58.57458,0,0,1,13.16448,3.744V23.06717h17.81437V143.17838H996.82037l-1.6305-8.21274a71.31873,71.31873,0,0,1-14.43266,7.12576,35.508,35.508,0,0,1-10.32635,1.93241,27.95949,27.95949,0,0,1-20.41108-7.30692,30.19417,30.19417,0,0,1-7.42767-22.70579Zm17.63321,23.672a14.67412,14.67412,0,0,0,3.6233,11.47366,13.52689,13.52689,0,0,0,9.179,3.07978,19.08227,19.08227,0,0,0,5.31406-.42271,38.16478,38.16478,0,0,0,6.03877-1.872,52.96468,52.96468,0,0,0,6.03878-2.65706,61.05489,61.05489,0,0,0,5.43486-3.20056V81.0394a86.71738,86.71738,0,0,0-10.99061-3.62327,44.80772,44.80772,0,0,0-9.78279-1.26814,13.40594,13.40594,0,0,0-14.85533,15.21772Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71981,142.21218V25.72423H369.8749l30.85814,74.76,30.85814-74.76H456.169V142.21218H435.63715v-77.719L408.34191,126.3906H393.66769l-27.416-59.965v75.78661Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.77614,142.21218H478.99555V61.05106h18.78059Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.05975,126.33021a8.21272,8.21272,0,0,1-9.11856-9.42049V26.32811H517.1606v95.53341a22.887,22.887,0,0,0,5.4953,16.42546,19.74688,19.74688,0,0,0,14.97618,6.03877,55.07459,55.07459,0,0,0,8.75621-.785,34.66149,34.66149,0,0,0,5.07255-1.087V126.33021Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.21761,103.50364H582.319v38.70854H563.23643V26.26772h18.96174V89.9164h3.5629a7.72955,7.72955,0,0,0,6.03878-3.26094l18.47863-25.6044h21.37727L610.39928,89.91641a25.42073,25.42073,0,0,1-3.07979,3.86481,29.772,29.772,0,0,1-3.44209,2.83822v.36232a15.03648,15.03648,0,0,1,3.14014,3.14017,24.63784,24.63784,0,0,1,3.20054,4.64986l23.85319,37.44039H612.694l-20.89415-34.9645A7.66921,7.66921,0,0,0,585.21761,103.50364Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.69873,64.55355a24.15476,24.15476,0,0,1,5.31415,16.7274v60.93123H824.53425V87.4405a16.3043,16.3043,0,0,0-2.174-8.99777,8.69579,8.69579,0,0,0-7.307-2.59668,18.7203,18.7203,0,0,0-8.5147,1.93241,88.70964,88.70964,0,0,0-12.07754,7.79v56.6437H776.34477V87.4405a13.22493,13.22493,0,0,0-2.05317-9.05816,9.4808,9.4808,0,0,0-7.36731-2.53629,18.11629,18.11629,0,0,0-8.33349,1.93241,104.53266,104.53266,0,0,0-12.07755,7.66924v56.76448H727.73266V61.05106h15.39889l1.20774,12.07755A62.139,62.139,0,0,1,759.07391,62.44a33.27365,33.27365,0,0,1,14.91574-3.56288,18.11633,18.11633,0,0,1,19.50521,13.58724A41.84873,41.84873,0,0,1,822.36019,58.8771,19.68644,19.68644,0,0,1,837.69873,64.55355Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.84412,65.03665a28.98612,28.98612,0,0,1,6.94456,22.04153v55.134H1082.8729l-2.05316-12.07755a43.11667,43.11667,0,0,1-12.07755,9.964,33.15268,33.15268,0,0,1-16.667,4.16676,24.75894,24.75894,0,0,1-17.3917-6.03877,22.64529,22.64529,0,0,1-6.8842-17.45206v-8.51467a19.32428,19.32428,0,0,1,6.03877-15.09693,24.155,24.155,0,0,1,16.60663-5.25373h28.56338V86.897a18.71977,18.71977,0,0,0-1.32854-7.18613,6.522,6.522,0,0,0-4.10632-3.38172,27.77845,27.77845,0,0,0-8.5147-1.02659c-7.97122,0-18.59943.54349-31.82436,1.69085l-1.872-14.2515c5.49531-1.087,12.07755-2.05319,19.38451-2.83823a183.699,183.699,0,0,1,18.65979-1.14736A31.52237,31.52237,0,0,1,1090.84412,65.03665Zm-41.9091,60.38774a10.32635,10.32635,0,0,0,7.54847,2.41551,28.92526,28.92526,0,0,0,10.80936-2.41551,40.94235,40.94235,0,0,0,11.53408-7.18614v-12.621h-24.1551a8.09185,8.09185,0,0,0-6.03877,2.4759,10.74882,10.74882,0,0,0-1.7512,6.64265v3.14017A10.387,10.387,0,0,0,1048.935,125.42439Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.35567,
    cy: 35.56743,
    r: 9.84319,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59969,51.81174l19.74679,34.23984L177.17763,146.43932s-63.76946,38.52739-109.66414-40.94289L99.9417,86.77623s21.07532,46.61933,57.60991,25.42323Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.80718,105.01333,0,70.77349,106.4032,9.35915S170.17265-29.22861,216.06732,50.302l-32.4282,18.7202S162.50341,22.40291,125.96883,43.599Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.69622,104.16791a26.02712,26.02712,0,1,0-26.02963-26.0246q0,.17991.00252.35981A25.96674,25.96674,0,0,0,142.69622,104.16791Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.90687,144.92963a13.58724,13.58724,0,1,0-13.58725-13.58724A13.58724,13.58724,0,0,0,50.90687,144.92963Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.13046,40.09651a13.58724,13.58724,0,1,0-13.58738-13.5871l.00014.06025A13.52686,13.52686,0,0,0,232.07,40.09665Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.82726,219.133h-13.99713v-7.18728h35.81217V219.133h-13.99713v36.94634h-7.81791Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.3,211.94573h32.72159v6.935h-24.96723v11.47461h22.12987v6.936h-22.12987v11.853h25.28207v6.935H1265.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.04058,249.64884l4.66571-5.5486c4.22379,3.6567,8.44854,5.7373,13.93359,5.7373,4.79183,0,7.8179-2.20673,7.8179-5.67472,0-3.15219-1.76577-4.85442-9.962-6.80889-9.394-2.20673-14.69035-4.98055-14.69035-13.24038,0-7.56565,6.30536-12.79845,15.06873-12.79845a24.45906,24.45906,0,0,1,16.01419,5.5486l-4.16121,5.86343c-3.97153-2.96349-7.944-4.53959-11.97911-4.53959-4.53958,0-7.18727,2.33286-7.18727,5.35893,0,3.40444,2.01706,4.918,10.46559,6.935,9.33143,2.27027,14.18584,5.61117,14.18584,13.05166,0,8.25887-6.49406,13.17683-15.76193,13.17683A27.18624,27.18624,0,0,1,1314.04058,249.64884Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.71476,219.133h-13.99713v-7.18728h35.81217V219.133h-13.99713v36.94634h-7.81791Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.18749,211.94573h7.18727l23.64242,30.51487V211.94573h7.6292v44.13362h-6.49406l-24.3366-31.39775v31.39775h-7.62823Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.45722,211.94573h32.7216v6.935h-24.96724v11.47461h22.12988v6.936h-22.12988v11.853h25.28207v6.935h-33.03643Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.00528,219.133h-13.99713v-7.18728h35.81121V219.133h-13.99617v36.94634h-7.81791Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdjedTestnetWhite);
export default __webpack_public_path__ + "static/media/mdjed_testnet_white.497b8598.svg";
export { ForwardRef as ReactComponent };